import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VideoBitrateBufferSizeInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';
import { VideoBitrateEnum } from '../../../types/enums/VideoBitrateEnum';
import Help from '../../Help/Help';

const VideoBitrateBufferSizeInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ size, setSize ] = useState<number>(project.encoder.transcoderVideoBitrateBufferSize);
  const debounce = 100;
  const min = VideoBitrateEnum.Low;
  const max = VideoBitrateEnum.High * 2;

  const onAfterChange = (data: string) => {
    if (project.encoder) {
      let value = size;

      if (value < min) {
        value = min;
      } else if (value > max) {
        value = max;
      }

      setSize(value);

      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          transcoderVideoBitrateBufferSize: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoBitrateBufferSize: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setSize(project.encoder.transcoderVideoBitrateBufferSize);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.transcoderVideoBitrateBufferSize]);

  return (
    <div className="video-bitrate-buffer-size-input">
      <div className="input-title">
        {t('producer.inputs.video-bitrate-buffer-size.title')}
        <Help
          title="Bitrate Buffer Size"
          text="Bitrate Buffer Size determines the amount of data reserved to handle fluctuations in your stream's bitrate.<br/><br/>- A larger buffer helps smooth out temporary spikes in video complexity, preventing sudden drops in quality.<br/>- A smaller buffer uses less memory but may result in more noticeable quality fluctuations.<br/><br/>Adjust this setting to balance smooth playback with resource usage."
        />
      </div>
      <TextInput
        placeholder="producer.inputs.video-bitrate-buffer-size.placeholder"
        value={size.toString()}
        onChange={(value) => {setSize(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">
        {t('producer.inputs.video-bitrate-buffer-size.footer')}
      </div>
    </div>
  );
};

export default React.memo(VideoBitrateBufferSizeInput);
